import PropTypes from 'prop-types';
const SVGComponent =({ fill = '#FAFAFA', ...props })  => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    className="__web-inspector-hide-shortcut__"
    {...props}
  >
    <circle cx={8.49998} cy={5.71434} r={3.42857} fill={fill} />
    <path
      d="M0.5 16.0001C0.5 12.8441 3.05837 10.2858 6.21428 10.2858H10.7857C13.9416 10.2858 16.5 12.8441 16.5 16.0001H0.5Z"
      fill={fill}
    />
    <path d="M2.21429 0H0.5V1.71429L2.21429 0Z" fill={fill} />
    <path d="M3.5 0L0.5 3V4L4.5 0H3.5Z" fill={fill} />
    <path d="M5.5 0L0.5 5V6L6.5 0H5.5Z" fill={fill} />
    <path d="M7.5 0L0.5 7V8L8.5 0H7.5Z" fill={fill} />
    <path d="M4.5 5L0.5 9V10L4.5 6V5Z" fill={fill} />
    <path d="M4.5 7L0.5 11V12L4.5 8V7Z" fill={fill} />
  </svg>
);

SVGComponent.propTypes = {
  fill: PropTypes.string,
};


export default SVGComponent;
